import { z } from 'zod';
import { zodI18nMap } from 'zod-i18n-map';
export * from './form-controller';
export * from './schemas/schemas';
z.setErrorMap(zodI18nMap);
//# sourceMappingURL=index.js.map